import styles from "./OrderType.module.css";
import { DELIVERY_TYPE } from "../../Utility/enums.ts";

export default function OrderType({
  selectedOrderType,
  onChangeOrderType,
  isCustomer,
  showOnlyTakeAway = false,
  isNew,
  allowedDeliveryType,
}) {
  const handleChange = (e) => {
    onChangeOrderType(parseInt(e.target.value));
  };

  // 1-Home Delivery,2-Takeaway,3-Store Pickup

  const showHomeDelivery =
    !isCustomer || allowedDeliveryType !== DELIVERY_TYPE.Customer_Pickup;
  const showSelfPickup =
    !isCustomer || allowedDeliveryType !== DELIVERY_TYPE.Door_Delivery;

  return (
    <div className={styles.orderTypeContainer}>
      {!showOnlyTakeAway && showHomeDelivery && (
        <label className={styles.radioLabel}>
          <input
            type="radio"
            name="orderType"
            value={"1"}
            checked={selectedOrderType === 1}
            onChange={handleChange}
          />
          <span className={styles.customRadio}></span>
          {isCustomer ? "Door Delivery" : "Delivery Partner"}
        </label>
      )}
      {(isCustomer || showOnlyTakeAway) && showSelfPickup && (
        <label className={styles.radioLabel}>
          <input
            type="radio"
            name="orderType"
            value={"2"}
            checked={selectedOrderType === 2}
            onChange={handleChange}
          />
          <span className={styles.customRadio}></span>
          {isCustomer ? "Self Pickup" : "Customer Pickup"}
        </label>
      )}
      {!isCustomer && (!showOnlyTakeAway || isNew) && (
        <label className={styles.radioLabel}>
          <input
            type="radio"
            name="orderType"
            value={"3"}
            checked={selectedOrderType === 3}
            onChange={handleChange}
          />
          <span className={styles.customRadio}></span>
          Delivery by Store
        </label>
      )}
    </div>
  );
}
